export default __webpack_public_path__ + "c64e7e354c88e613c77cab8ac2ebc3ae.woff2";